import React, {Component} from 'react';
import logo from '../../images/logo_black.svg'
import {toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import {Dispatch} from "redux";
import {ActionType} from "../../reducers/types";
import {injectIntl, IntlShape} from 'react-intl';
import {connect} from "react-redux";
import {PrimaryButton} from "../../components/CustomUIComp/CustomFormElem";
import {RouteComponentProps} from "react-router";
import md5 from "js-md5";
import {SALT_STRING} from "../../constants";

interface IProps extends RouteComponentProps<any>{
    dispatch: Dispatch<ActionType<any>>,
    intl: IntlShape,
}

interface IState {
    // email: string,
    password: string,
    confirmPass: string
}
class Validation extends Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            // email: '',
            password: '',
            confirmPass: ''
        }
    }
    // handleEmailChange = (e: any): void => {
    //     this.setState({email: e.target.value})
    // }
    handlePasswordChange = (e: any): void => {
        this.setState({password: e.target.value})
    }
    handleConfirmPasswordChange = (e: any): void => {
        this.setState({confirmPass: e.target.value})
    }
    _check = (): boolean => {
        let {intl} = this.props
        // if (!this.state.email) {
        //     toast(intl.formatMessage({id: 'userNameNotNull'}));
        //     return false
        // }
        if (!this.state.password){
            toast(intl.formatMessage({id: 'passwrodNotNull'}));
            return false
        }
        if (this.state.password.length < 6){
            toast(intl.formatMessage({id: 'passLengthError'}));
            return false
        }
        if (this.state.password !== this.state.confirmPass){
            toast(intl.formatMessage({id: 'passConfirmError'}));
            return false
        }
        return true
    }
    confirm = () => {
        console.log(this.props)
        let search  = this.props.location.search
        let matched = search.match(/(\?uuid=)(.*)/)
        let uuid = ''
        if(matched && matched.length === 3){
            uuid = matched[2]
        }
        console.log(uuid)
        if(!uuid){
            toast('錯誤')
        }else{
            if (this._check()) {
                let password = md5(this.state.password + SALT_STRING)

                let params = {
                    clientId: 'h5',
                    email: 'email',
                    password: password,
                    uuid: uuid
                }
                this.props.dispatch({type: 'RESET_PASSWORD', payload: params})
            }
        }
    }


    public render() {
        return (
            <div className="LoginPage">
                <div className="topBar">
                    <img src={logo} alt="logo" className="logo"/>
                </div>
                <div className="LoginForm">
                    <h2>{this.props.intl.formatMessage({id: 'resetPassword'})}</h2>
                    <div>{this.props.intl.formatMessage({id: 'resetPasswordTips'})}</div>
                    <div className="formLine">
                        {/*<label>{this.props.intl.formatMessage({id: 'email'})}</label>*/}
                        {/*<input placeholder={this.props.intl.formatMessage({id:'email'})}*/}
                               {/*value={this.state.email} onChange={this.handleEmailChange}/>*/}
                        <input type="password" placeholder={this.props.intl.formatMessage({id:'password'})}
                               value={this.state.password} onChange={this.handlePasswordChange}/>
                        <input type="password" placeholder={this.props.intl.formatMessage({id:'confirmPass'})}
                               value={this.state.confirmPass} onChange={this.handleConfirmPasswordChange}/>
                    </div>
                    <div className="buttons">
                        <PrimaryButton className="confirmButtom" onClick={this.confirm}>
                            {this.props.intl.formatMessage({id: 'confirm'})}
                        </PrimaryButton>
                    </div>
                </div>
            </div>
        );
    }
}

export default injectIntl(connect()(Validation));


